import React from 'react'
import { Button } from 'lib/ui/components'

interface Props {
  card: {
    type: string
    last4: string
    expiration: string
  }
  description: string
  isDisabled: boolean
  onDelete: () => void
}

export const Item = ({
  description,
  card,
  isDisabled,
  onDelete
}: Props) => {
  const cardTitle = 'Payment Method'

  return (
    <>
      <p><strong>{cardTitle}</strong></p>
      <div className='card'>
        <div className='address'>
          <div className='border-box'>
            <p><strong>{card.type}<br />**** **** **** {card.last4}</strong></p>
          </div>
        </div>
        <div className='address'>
          <div className='border-box'>
            <p>Expires {card.expiration}</p>
            <p>{description}</p>
          </div>
        </div>
        <div className='actions'>
          <Button
            isDisabled={isDisabled}
            onClick={onDelete}
            skin={Button.SKIN.TEXT}
          >
            Delete
          </Button>
        </div>
      </div>
    </>
  )
}
